import { createEvent } from 'effector';
import { AgentMetricsDateTypeType } from '../types';

export const onAgentMetricsReset = createEvent<void>('onAgentMetricsReset');
export const onAgentMetricsSetDate = createEvent<Date>('onAgentMetricsSetDate');
export const onAgentMetricsSetType = createEvent<AgentMetricsDateTypeType>('onAgentMetricsSetType');
